//* Libraries imports
import { QrCode, CreditCard, Barcode, Landmark } from "lucide-react";
import { cn } from "@/lib/utils";

//* Types
import {
  MethodPaymentEnum,
  MethodPaymentEnumLabel,
  type MethodPaymentDTO,
} from "@/schemas/methodpayment";

type PaymentMethodsProps = {
  selectedMethod: MethodPaymentDTO;
  onSelectMethod: (method: MethodPaymentDTO) => void;
  allowedMethods?: MethodPaymentDTO[];
};

export function PaymentMethods({
  selectedMethod,
  onSelectMethod,
  allowedMethods,
}: PaymentMethodsProps) {
  const allMethods = [
    {
      id: MethodPaymentEnum.CREDIT_CARD,
      label: MethodPaymentEnumLabel[MethodPaymentEnum.CREDIT_CARD],
      icon: CreditCard,
    },
    {
      id: MethodPaymentEnum.PIX,
      label: MethodPaymentEnumLabel[MethodPaymentEnum.PIX],
      icon: QrCode,
    },
    {
      id: MethodPaymentEnum.BOLETO,
      label: MethodPaymentEnumLabel[MethodPaymentEnum.BOLETO],
      icon: Barcode,
    },
    {
      id: MethodPaymentEnum.TED,
      label: MethodPaymentEnumLabel[MethodPaymentEnum.TED],
      icon: Landmark,
    },
  ];

  const methods = allowedMethods
    ? allMethods.filter((m) => allowedMethods.includes(m.id))
    : allMethods;

  return (
    <section className="flex flex-col gap-3">
      <span className="text-clarotexto-202 text-xs font-semibold uppercase tracking-wider">
        Forma de Pagamento
      </span>
      <div className="grid grid-cols-2 gap-2">
        {methods.map((method) => {
          const Icon = method.icon;
          return (
            <button
              key={method.id}
              onClick={() => onSelectMethod(method.id)}
              className={cn(
                "h-10 rounded-lg border text-xs font-medium transition-all flex items-center justify-center gap-2",
                selectedMethod === method.id
                  ? "bg-claroprimaria-01 border-claroprimaria-01 text-white shadow-md"
                  : "bg-clarobg-202 border-clarobordas-01 text-clarotexto-202 hover:border-claroprimaria-01/50",
              )}
            >
              <Icon size={16} />
              {method.label}
            </button>
          );
        })}
      </div>
    </section>
  );
}
